'use client'
import { PrismicLink } from '@prismicio/react'
import { usePathname } from 'next/navigation'
import { getLangPath } from '@/utils/getLangFormat'
import { useTranslation } from '@/hooks/useTranslation'

import { useLocale } from '@/context/LocaleContext'

type GetSidebarLinkProps = {
  className?: string
}

const GetSidebarLink = ({ className }: GetSidebarLinkProps) => {
  const pathname = usePathname()
  const locale = useLocale()
  const { t } = useTranslation(locale)

  const getTermsActiveClass = (pathname: string): string => {
    const allPathName = ['/terms', '/de-de/terms', '/es-es/terms', '/fr-fr/terms']
    return allPathName.includes(pathname) ? 'active' : ''
  }

  const getPrivacyActiveClass = (pathname: string): string => {
    const allPathName = ['/privacy', '/de-de/privacy', '/es-es/privacy', '/fr-fr/privacy']
    return allPathName.includes(pathname) ? 'active' : ''
  }

  const getDpaActiveClass = (pathname: string): string => {
    const allPathName = ['/dpa', '/de-de/dpa', '/es-es/dpa', '/fr-fr/dpa']
    return allPathName.includes(pathname) ? 'active' : ''
  }

  const getSubProcessorsActiveClass = (pathname: string): string => {
    const allPathName = ['/subprocessors', '/de-de/subprocessors', '/es-es/subprocessors', '/fr-fr/subprocessors']
    return allPathName.includes(pathname) ? 'active' : ''
  }

  const getServicePartnerAgrementActiveClass = (pathname: string): string => {
    const allPathName = [
      '/service-partner-agreement',
      '/de-de/service-partner-agreement',
      '/es-es/service-partner-agreement',
      '/fr-fr/service-partner-agreement',
    ]
    return allPathName.includes(pathname) ? 'active' : ''
  }

  const getDpaPath = (locale: string) => `/${getLangPath(locale)}/dpa`
  const getTermsPath = (locale: string) => `/${getLangPath(locale)}/terms`
  const getPrivacyPath = (locale: string) => `/${getLangPath(locale)}/privacy`
  const getSubprocessorsPath = (locale: string) => `/${getLangPath(locale)}/subprocessors`
  const getServicePartnerAggrementPath = (locale: string) => `/${getLangPath(locale)}/service-partner-agreement`

  return (
    <ul className={className}>
      <li>
        <PrismicLink
          href={locale === 'en-us' ? '/terms' : getTermsPath(locale)}
          className={getTermsActiveClass(pathname)}>
          {t('terms_of_service')}
        </PrismicLink>
      </li>
      <li>
        <PrismicLink
          href={locale === 'en-us' ? '/privacy' : getPrivacyPath(locale)}
          className={getPrivacyActiveClass(pathname)}>
          {t('privacy_policy')}
        </PrismicLink>
      </li>
      <li>
        <PrismicLink href={locale === 'en-us' ? '/dpa' : getDpaPath(locale)} className={getDpaActiveClass(pathname)}>
          {t('data_processing_addendum')}
        </PrismicLink>
      </li>
      <li>
        <PrismicLink
          href={locale === 'en-us' ? '/subprocessors' : getSubprocessorsPath(locale)}
          className={getSubProcessorsActiveClass(pathname)}>
          {t('subprocessors')}
        </PrismicLink>
      </li>
      <li>
        <PrismicLink
          href={locale === 'en-us' ? '/service-partner-agreement' : getServicePartnerAggrementPath(locale)}
          className={getServicePartnerAgrementActiveClass(pathname)}>
          {t('service_partner_agreement')}
        </PrismicLink>
      </li>
    </ul>
  )
}

export default GetSidebarLink
